<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('daz.t1.title')"
      :textArray="[$t('daz.t1.p0'), $t('daz.t1.p1')]"
    >
      <v-row slot="content">
        <v-col cols="12" align="center">
          <ExternalLinkButton
            :themeColor="computedTopicColor"
            :href="homepageLink"
            :text="$t('daz.t1.link')"
          />
        </v-col>
      </v-row>
    </ContentTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('daz.t2.title')"
      :textArray="[$t('daz.t2.p0')]"
    >
      <ul slot="content">
        <li>{{ $t('daz.t2.li0') }}</li>
        <li>{{ $t('daz.t2.li1') }}</li>
        <li>{{ $t('daz.t2.li2') }}</li>
        <li>{{ $t('daz.t2.li3') }}</li>
        <li>{{ $t('daz.t2.li4') }}</li>
      </ul>
    </ContentTile>
    <ContentImageTile
      imageSource="/img/grafiken/mithilfe-2.jpg"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('daz.t3.title')"
      :textArray="[$t('daz.t3.p0')]"
    >
      <v-card slot="content">
        <v-card-text>
          <p class="text-subtitle-1">
            {{ $t('daz.t3.bankheading') }}
          </p>
          Dazugehoeren e.V.
          <br>IBAN: DE36 1007 0124 0139 3636 00
          <br>BIC: DEUTDEDB101
        </v-card-text>
      </v-card>
    </ContentTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('daz.t4.title')"
      :textArray="[$t('daz.t4.p0'), $t('daz.t4.p1')]"
    >
      <v-row slot="content">
        <v-col cols="12" align="center">
          <ExternalLinkButton
            :themeColor="computedTopicColor"
            :href="newsletterLink"
            :text="$t('daz.t4.link')"
          />
        </v-col>
      </v-row>
    </ContentTile>
  </ContentFrame>
</template>

<script>
import ContentFrame from '@/views/components/ContentFrame.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'
import ExternalLinkButton from '@/views/components/ExternalLinkButton.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Dazugehoeren',
  components: {
    ContentTile,
    ContentFrame,
    ContentImageTile,
    ExternalLinkButton
  },
  data () {
    return {
      homepageLink: 'https://dazugehoeren.info',
      newsletterLink: 'https://dazugehoeren.info/newsletter'
    }
  },
  computed: {
    ...mapGetters(['menuData']),
    computedTopicColor () {
      return this.menuData.dazugehoeren.color
    },
    computedTitle () {
      return this.menuData.dazugehoeren.title
    }
  }
}
</script>
